export default class QueryWhereItem
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryWhereItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	fieldValue;	//String
		
	andOr;	//String
	leftBracket;	//String	//QueryWhereLeftBracket
	rightBracket;	//String	//QueryWhereRightBracket
		
	label;	//String
	status;	//String			//QueryWhereStatus
	fieldType;	//String	//QueryWhereFieldType
	
	tag;	//String
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryWhereItem.js